module.exports = __webpack_public_path__ + "img/z-logo-sm-midnight.af3b1aae.svg";